<template>
    <svg class="icon-play fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 9.5"><path d="M8,4.75,0,9.5V0Z" /></svg>
</template>